import React, { Component } from "react";
import { ajaxWrapper } from "functions";
import settings from "base/settings.js";
import { Container, Button } from "library";

import FancySpellSheet from "pages/monsters/fancy_char_sheet/spell_main.js";
import FancyBioSheet from "pages/monsters/fancy_char_sheet/bio_main.js";
import FancyCharSheet from "pages/monsters/fancy_char_sheet/main.js";
import LevelUp from "pages/forms/level_up.js";

import save_monster from "pages/session_tools/global_data/save_monster.js";
import save_monster_instance from "pages/session_tools/global_data/save_monster_instance.js";

export default class ModalFancyCharSheet extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			updated_timestamp: new Date().valueOf(),
		};

		this.update_monster_relay = this.update_monster_relay.bind(this);
		this.update_instance_relay = this.update_instance_relay.bind(this);
		this.level_up = this.level_up.bind(this);
	}

	componentDidMount() {
		window.secret_react_state.subscribe_by_name(this, "selected_monster_instance");
		window.secret_react_state.subscribe_by_name(this, "resources");
		window.secret_react_state.subscribe_by_name(this, "equipment");
		window.secret_react_state.subscribe_by_name(this, "monsters");
	}

	level_up() {
		var instance = this.props.instance;
		var monster = window.secret_react_state.global_state_lookup(this, "monsters", this.props.monster_id);

		var data = {
			instance: instance,
			monster: monster,
			resources: window.secret_react_state.resources,
			equipment: window.secret_react_state.equipment,
			update_monster: this.update_monster_relay,
			update_instance: this.update_instance_relay,
			push_modal_content: this.props.push_modal_content,
			use_action: this.props.use_action,
			add_action_token: this.props.add_action_token,
			roll_skill: this.props.roll_skill,
		};

		this.props.push_modal_content(<LevelUp {...data} />);
	}

	update_monster_relay(name, data, only_state) {
		var monster = window.secret_react_state.global_state_lookup(this, "monsters", this.props.monster_id);
		data["id"] = monster.id;

		var level = data["level"] || monster.level;
		data["proficiency_bonus"] = parseInt((level - 1) / 4) + 2;

		var spellcasting_modifier = 0;

		//this is only mostly going to be accurate until we build in classes
		if (monster.spellcasting_ability) {
			spellcasting_modifier += Math.floor(monster[monster.spellcasting_ability] / 2) - 5;
		} else {
			var max_bonus = 0;
			if (monster.intelligence >= monster.wisdom && monster.intelligence >= monster.charisma) {
				console.log("INT");
				max_bonus = Math.floor(monster.intelligence / 2) - 5;
			} else if (monster.wisdom >= monster.intelligence && monster.wisdom >= monster.charisma) {
				console.log("WIS");
				max_bonus = Math.floor(monster.wisdom / 2) - 5;
			} else if (monster.charisma >= monster.wisdom && monster.charisma >= monster.intelligence) {
				console.log("CHA");
				max_bonus = Math.floor(monster.charisma / 2) - 5;
			}
			spellcasting_modifier += max_bonus;
		}

		if (monster.spellcasting_modifier != spellcasting_modifier) {
			data["spellcasting_modifier"] = spellcasting_modifier;
		}

		console.log("Update Monster Relay", data);
		save_monster(data);

		this.setState({
			updated_timestamp: new Date().valueOf(),
		});
	}

	update_instance_relay(name, data, only_state) {
		var instance = this.props.instance;
		data["id"] = instance.id;
		console.log("Update Monster Instance Relay", data);
		save_monster_instance(data);

		this.setState({
			updated_timestamp: new Date().valueOf(),
		});
	}

	render() {
		var instance = this.props.instance;
		var monster = window.secret_react_state.global_state_lookup(this, "monsters", this.props.monster_id);

		var data = {
			instance: instance,
			monster: monster,
			update_monster: this.update_monster_relay,
			update_instance: this.update_instance_relay,
			push_modal_content: this.props.push_modal_content,
			use_action: this.props.use_action,
			add_action_token: this.props.add_action_token,
			roll_skill: this.props.roll_skill,
			dm_view: this.props.dm_view,
		};

		var content = (
			<Container>
				<Button type="primary" text="Level Up" onClick={this.level_up} />
				<FancyCharSheet {...data} />

				<div>
					<br />
					<br />
					<br />
				</div>
				<div style={{ borderTop: "2px solid black" }}>
					<br />
					<br />
					<br />
				</div>

				<FancySpellSheet {...data} />

				<div>
					<br />
					<br />
					<br />
				</div>
				<div style={{ borderTop: "2px solid black" }}>
					<br />
					<br />
					<br />
				</div>

				<FancyBioSheet {...data} />
			</Container>
		);

		return content;
	}
}
